<script setup lang="ts">
import BaseButton from "@/components/base/BaseButton.vue";
import Balance from "@/components/balance/Balance.vue";
import TariffMain from "@/components/tariff/TariffMain.vue";
import { reactive, ref } from "vue";
import { TariffOptionStruct } from "@/struct/TariffStruct";
import AddonsMain from "@/components/addons/AddonsMain.vue";
import { AddonsItemStruct } from "@/struct/AddonsStruct";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import type { Base64File } from "@/struct/FileTypes";
import BaseDrop from "@/components/base/BaseDrop.vue";
import BaseFeedback from "@/components/base/BaseFeedback.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import BaseModal from "@/components/base/BaseModal.vue";
import BaseProgressBar from "@/components/base/BaseProgressBar.vue";
import BasePromocode from "@/components/base/BasePromocode.vue";
import BaseSelect from "@/components/base/BaseSelect.vue";
import BaseSwitcher from "@/components/base/BaseSwitcher.vue";
import { useStore } from "vuex";
import { TypesModals } from "@/config/modals";
import { useI18n } from "vue-i18n";

const store = useStore();
const { t } = useI18n();

const options = reactive<TariffOptionStruct[]>([
  {
    value: 185,
    maximum: 300,
    id: "gb",
  },
  {
    value: 5,
    maximum: 10,
    id: "min",
  },
  {
    value: 0,
    maximum: 10,
    id: "sms",
  },
]);
const optionsBlocked = reactive<TariffOptionStruct[]>([
  {
    value: 0,
    maximum: 300,
    id: "gb",
  },
  {
    value: 0,
    maximum: 10,
    id: "min",
  },
  {
    value: 0,
    maximum: 10,
    id: "sms",
  },
]);

const isAccepted = ref<boolean>(false);
const files = ref<Base64File[]>([]);
const feedbackModal = ref<boolean>(false);
const isOpenBaseModal = ref<boolean>(false);
const activeValue = ref(50);
const maxValue = ref(200);

const formInput = reactive({
  phone: "",
  code: "",
  digit: "",
  email: "",
  text: "",
  area: "",
});

const addons = reactive<AddonsItemStruct[]>([
  {
    title: t("uiKit.samples.unlimitedMessengers"),
    amount: 0,
    date: t("uiKit.labels.sampleDate"),
    servicesList: ["yandex-maps", "yandex-music", "vk", "ok", "rutube"],
  },
  {
    title: t("uiKit.samples.roamingInternet"),
    amount: 12,
    date: t("uiKit.labels.sampleDate"),
    unitData: {
      value: 50,
      maximum: 300,
      id: "gb",
    },
  },
  {
    title: t("uiKit.samples.roamingInternet"),
    amount: 0,
    date: t("uiKit.labels.sampleDate"),
    unitData: {
      value: 0,
      maximum: 10,
      id: "sms",
    },
  },
]);

const itemsSelect = ref(["Элемент1", "Элемент2", "Элемент3", "Элемент4"]);
const selected = ref("Элемент1");
const handleFeedbackSubmitResult = (isSuccess: boolean) => {
  alert(`handleFeedbackSubmitResult => isSuccess: ${isSuccess}`);
};
const openBaseFeedback = () => {
  feedbackModal.value = true;
};
const presetKeys = ref<TypesModals>(["no_funds", "general_error"]);
const openBaseModal = (modalKey: TypesModals) => {
  store.dispatch("system/openModal", {
    presetKey: modalKey,
    /*overrides: {
    все поля overrides опциональны
      title: "С предыдущей смены номера не прошло 6 месяцев",
      mainBtnTitle: "Продолжить"

      text?: string;
      status?: "success" | "default" | "error";
      secondaryBtnTitle?:
      mainBtnLoading?: boolean;
      secondaryBtnLoading?: boolean;

      onAction?: () => void; (default: закрытие) приписать если нужно иное
      onSecondaryAction?: () => void;
    },*/
  });
};
const toggleModal = (state: boolean) => {
  isOpenBaseModal.value = state;
};
</script>

<template>
  <div class="ui-kit">
    <div class="ui-kit__wrapper">
      <div class="ui-kit__grid">
        <div class="ui-kit__container">
          <div class="ui-kit__text">
            <span>{{ t("uiKit.labels.buttonsFullWidth") }}</span>
          </div>
          <div class="ui-kit__row">
            <BaseButton
              :title="t('uiKit.samples.topUp')"
              size="large"
              color="primary"
            />
            <BaseButton
              :title="t('uiKit.samples.topUp')"
              size="large"
              color="grey"
            />

            <BaseButton
              :title="t('uiKit.samples.topUp')"
              size="large"
              color="transparent-white"
            />
            <BaseButton
              :title="t('uiKit.samples.topUp')"
              size="large"
              color="transparent-black"
            />
            <BaseButton
              :title="t('uiKit.samples.topUp')"
              size="large"
              color="white"
            />

            <BaseButton
              :title="t('uiKit.samples.topUp')"
              size="medium"
              color="primary"
            />
          </div>
        </div>
      </div>

      <div class="ui-kit__container">
        <div class="ui-kit__text">
          <span>BaseCheckbox </span>
        </div>
        <div class="ui-kit__row --line --wrap">
          <BaseCheckbox v-model="isAccepted" />
        </div>
      </div>

      <div class="ui-kit__container">
        <div class="ui-kit__text">
          <span>BaseDrop </span>
        </div>
        <div class="ui-kit__row --line --wrap">
          <BaseDrop @update:files="files = $event" />
        </div>
      </div>

      <div class="ui-kit__container">
        <div class="ui-kit__text">
          <span>BaseFeedback </span>
        </div>
        <div class="ui-kit__row --line --wrap">
          <BaseButton title="Открыть BaseFeedback" @click="openBaseFeedback" />
          <BaseFeedback
            v-model="feedbackModal"
            @submit-result="handleFeedbackSubmitResult"
          />
        </div>
      </div>
      <div class="ui-kit__container">
        <div class="ui-kit__text">
          <span>BaseInput </span>
        </div>
        <div class="ui-kit__row">
          <BaseInput
            v-model="formInput.phone"
            type="phone"
            placeholder="Номер телефона"
          />
          <BaseInput v-model="formInput.code" type="code" placeholder="Код" />
          <BaseInput
            v-model="formInput.digit"
            type="digit"
            placeholder="Number"
            :max-length="11"
          />
          <BaseInput
            v-model="formInput.email"
            type="email"
            placeholder="Email"
          />

          <BaseInput v-model="formInput.text" type="text" placeholder="Text" />
          <BaseInput
            v-model="formInput.area"
            type="area"
            placeholder="Textarea"
          />
        </div>
      </div>
      <div class="ui-kit__container">
        <div class="ui-kit__text">
          <span>BaseModal </span>
        </div>
        <div class="ui-kit__row --line --wrap">
          <BaseButton
            v-for="(modalKey, index) in presetKeys"
            :key="index"
            :title="`Open BaseModal ${modalKey}`"
            @click="openBaseModal(modalKey)"
          />

          <BaseModal
            v-if="isOpenBaseModal"
            title="Произошла ошибка"
            main-btn-title="Закрыть окно"
            status="error"
            @close="toggleModal(false)"
            @action="toggleModal(false)"
          />
        </div>
      </div>
      <div class="ui-kit__container">
        <div class="ui-kit__text">
          <span>BaseProgressBar </span>
        </div>
        <div class="ui-kit__row">
          <BaseProgressBar
            :current-amount="activeValue"
            :max-amount="maxValue"
          />
        </div>
      </div>
      <div class="ui-kit__container">
        <div class="ui-kit__text">
          <span>BasePromocode </span>
        </div>
        <div class="ui-kit__row">
          <BasePromocode />
        </div>
      </div>
      <div class="ui-kit__container">
        <div class="ui-kit__text">
          <span>BaseSelect </span>
        </div>
        <div class="ui-kit__row">
          <BaseSelect
            placeholder="Выбор"
            :items="itemsSelect"
            v-model="selected"
          />
        </div>
      </div>
      <div class="ui-kit__container">
        <div class="ui-kit__text">
          <span>Blocks </span>
        </div>

        <div class="ui-kit__row --line --wrap --grey-bg">
          <Balance :amount="1490" />
          <TariffMain
            :amount="250"
            :old-amount="500"
            :discount="50"
            :options="options"
            next-date="30 декабря"
          />
          <TariffMain
            :amount="250"
            :old-amount="500"
            :discount="50"
            :options="optionsBlocked"
            next-date="30 декабря"
          />
        </div>
      </div>
      <div class="ui-kit__container">
        <div class="ui-kit__text">
          <span>Blocks Addons </span>
        </div>

        <div class="ui-kit__row --line --grey-bg">
          <AddonsMain :options="addons" />
        </div>
      </div>
      <div class="ui-kit__container">
        <div class="ui-kit__text">
          <span>BaseSwitcher </span>
        </div>

        <div class="ui-kit__row --line">
          <BaseSwitcher />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/style/main";

.customer-color-success {
  background-color: #007e00;
  color: var(--color-white);
}
.ui-kit {
  width: 100%;
  height: 100%;
  padding-top: 30px;

  &__wrapper {
    padding: 20px 41px;
    background-color: var(--color-white);
    border-radius: 20px;
  }
  &__grid {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    display: grid;
  }
  &__container {
  }
  &__text {
    padding: 20px 0 10px;
  }
  &__row {
    display: flex;
    flex-direction: column;
    gap: 15px;
    &.--grey-bg {
      background-color: var(--color-bg-primary);
      border-radius: 20px;
      padding: 15px;
    }
    &.--line {
      flex-direction: row;
      flex-wrap: nowrap;
      &.--wrap {
        flex-wrap: wrap;
      }
      .icon-block {
        display: flex;
        flex-direction: column;
        gap: 5px;
        align-items: center;
        &__name {
          font-size: 10px;
        }
        &__icon {
          color: red;
        }
      }
    }
  }
}
</style>
